import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../ui/CollapsiblePannel/Collapsible";
import { PriceDisplay } from "../../../../ui/PriceDisplay/PriceDisplay";
import { useWheelPrice } from "./useWheelPrice";
import { useWheelPriceOptions } from "./useWheelPriceOptions";

const id = "dealer-wheel-price-panel";

export const WheelPrice: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, togglePrice] = useWheelPrice();
  const options = useWheelPriceOptions();

  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.wheelPricing")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, count, range: [min, max], value }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={value}
        >
          <Checkbox
            onChange={(): void => {
              togglePrice(value);
            }}
            checked={checked}
            disabled={count === 0}
            name="brand"
          />
          <span className="flex-1">
            <PriceDisplay>{min}</PriceDisplay>
            {max === Infinity ? (
              "+"
            ) : (
              <span>
                {" "}
                &ndash; <PriceDisplay>{max}</PriceDisplay>
              </span>
            )}
          </span>
        </label>
      ))}
    </Collapsible>
  );
};

/**
 * @see docs/worklog/TW-859-combos-wheel-filters/rfc.md
 * @see docs/worklog/TW-859-combos-wheel-filters/tfc.md
 */
